// package.json
var version = "1.4.2";

// src/helpers/decode.ts
function decode(clientKey) {
  const binaryString = atob(clientKey);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return String.fromCharCode(...bytes);
}
function encode(key) {
  const bytes = new Uint8Array(key.length);
  for (let i = 0; i < key.length; i++) {
    bytes[i] = key.charCodeAt(i);
  }
  return btoa(String.fromCharCode(...bytes));
}

// src/helpers/client.ts
async function tryCatch(fn, debug = true) {
  var _a, _b;
  const response = await fn();
  if (!response.ok && debug) {
    console.error(
      `Error invoking ${response.url}: ${(_a = response.status) != null ? _a : 404} because ${JSON.stringify((_b = await response.json()) == null ? void 0 : _b.message)}`
    );
  }
}
var Courier = class {
  constructor({
    authorization,
    baseUrl,
    clientKey,
    debug = false,
    userId,
    userSignature
  }) {
    if (!clientKey) {
      throw new Error("Courier client key is required");
    }
    this.authorization = authorization;
    this.baseUrl = `${baseUrl != null ? baseUrl : "https://api.courier.com"}`;
    this.clientKey = clientKey;
    this.debug = debug;
    this.userId = userId;
    this.userSignature = userSignature;
  }
  getHeaders() {
    return new Headers({
      "Content-Type": "application/json",
      "x-courier-client-version": `courier-js@${version}`,
      "Access-Control-Allow-Origin": "*",
      ...this.authorization && { Authorization: this.authorization },
      ...this.userId && { "x-courier-user-id": this.userId },
      ...this.userSignature && {
        "x-courier-user-signature": this.userSignature
      },
      ...this.clientKey && { "x-courier-client-key": this.clientKey }
    });
  }
  async post(path, body, useClientPath = true) {
    const postFn = () => {
      return fetch(this.getPathURL(path, useClientPath), {
        body: JSON.stringify(body),
        headers: this.getHeaders(),
        method: "POST"
      });
    };
    await tryCatch(postFn, this.debug);
  }
  async put(path, body, useClientPath = true) {
    const putFn = () => {
      return fetch(this.getPathURL(path, useClientPath), {
        ...body ? { body: JSON.stringify(body) } : {},
        headers: this.getHeaders(),
        method: "PUT"
      });
    };
    await tryCatch(putFn, this.debug);
  }
  async delete(path, useClientPath = true) {
    const deleteFn = () => {
      return fetch(this.getPathURL(path, useClientPath), {
        headers: this.getHeaders(),
        method: "DELETE"
      });
    };
    await tryCatch(deleteFn, this.debug);
  }
  generatePreferencesUrl(userId, options) {
    var _a;
    if (!userId) {
      throw new Error("User ID is required to generate preferences URL");
    }
    const id = decode(this.clientKey);
    return `https://view.notificationcenter.app/p/${encode(
      `${id}#${(_a = options == null ? void 0 : options.brandId) != null ? _a : ""}#${userId}${(options == null ? void 0 : options.tenantId) ? `#${options.tenantId}` : ""}#${false}`
    )}`;
  }
  getPathURL(path, useClientPath) {
    let pathUrl = this.baseUrl;
    if (useClientPath) {
      pathUrl = pathUrl.concat("/client");
    }
    return pathUrl.concat(path);
  }
};

// src/index.ts
var client = {
  __instance: null,
  init(options) {
    this.__instance = new Courier(options);
  },
  get instance() {
    if (!this.__instance) {
      throw new Error("Courier instance not initialized");
    }
    return this.__instance;
  },
  async identify(userId, payload) {
    if (!userId) {
      throw new Error("userId is required");
    }
    await this.instance.post(`/identify/${userId}`, {
      profile: {
        ...payload
      }
    });
  },
  async subscribe(userId, listId) {
    if (!userId || !listId) {
      throw new Error("userId is required");
    }
    await this.instance.put(`/lists/${listId}/subscribe/${userId}`);
  },
  async track(event, properties) {
    if (!event) {
      throw new Error("event is required");
    }
    let indempotentKey = self.crypto.randomUUID ? self.crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    await this.instance.post(`/inbound/courier`, {
      messageId: indempotentKey,
      type: "track",
      event,
      properties: { ...properties }
    }, false);
  },
  async unsubscribe(userId, listId) {
    if (!userId || !listId) {
      throw new Error("userId is required");
    }
    this.instance.delete(`/lists/${listId}/unsubscribe/${userId}`);
  },
  generatePreferencesUrl(userId, options) {
    return this.instance.generatePreferencesUrl(userId, options);
  }
};
var src_default = client;
export {
  src_default as default
};
